import axios from "axios";
import * as Sentry from "@sentry/react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(
      `API error: ${error.config?.method?.toUpperCase()} ${error.config?.url} -> ${error.response?.status ?? "network error"}`,
      error.response?.data ?? error.message,
    );
    // Only report unexpected failures (server errors / network outages) —
    // 4xx responses are normal user-flow outcomes (bad password, plan limit, etc.)
    // and already handled/shown to the user, so reporting them would just add noise.
    if (!error.response || error.response.status >= 500) {
      Sentry.captureException(error);
    }
    return Promise.reject(error);
  },
);

export default api;
